module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/diventa-agente-small.27316564f3074470bace933adfdf73d4.jpg";